import { Link } from '@tanstack/react-router';
import { Icon } from '@/components/Icon';
import { navFor } from '@/app/nav';
import { useTier } from '@/session/SessionProvider';
import { SignOutButton } from '@/features/auth/SignOutButton';
import './More.css';

/**
 * The phone "More" screen.
 *
 * The tab bar holds the first four main destinations; everything past that — and every locked
 * destination — lands here. Locked rows read "Locked" and route to /pricing rather than being
 * hidden, so a Snapshot user can see the whole product from their phone.
 *
 * This route has no desktop equivalent: above the nav breakpoint every destination is already
 * in the sidebar.
 */
export function More() {
  const tier = useTier();
  const { moreRows } = navFor(tier);

  return (
    <div className="more">
      <h1 className="more__title">More</h1>
      <ul className="more__list">
        {moreRows.map(({ entry, locked }) => (
          <li key={entry.id}>
            <Link
              to={locked ? '/pricing' : entry.to}
              className="more__row"
              data-locked={locked}
              aria-label={locked ? `${entry.label} — locked, see plans` : undefined}
            >
              <Icon name={entry.icon} className="more__icon" />
              <span className="more__label">{entry.label}</span>
              {locked ? (
                <span className="more__value">
                  <Icon name="lock" /> Locked
                </span>
              ) : (
                <Icon name="chevron-right" className="more__chevron" />
              )}
            </Link>
          </li>
        ))}
      </ul>

      {/* Last, and separated. Sign out is the one destructive-feeling action on this screen;
          putting it inside the navigation list invites a mis-tap while scanning for a
          destination. */}
      <SignOutButton />
    </div>
  );
}
